import {Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {MatSelect} from "@angular/material/select";

interface Member {
  name: string,
  id: string,
  profileImg: string
}

@Component({
  selector: 'lib-members-select',
  templateUrl: './members-select.component.html',
  styleUrls: ['./members-select.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MembersSelectComponent implements OnInit {
  editMode = false;
  @Input() control: FormControl = new FormControl();
  @Input() markMember = false;
  private _membersList: Member[] = [];
  @Input() set membersList(val: Member[]) {
    if (val) {
      this._membersList = val;
      if (this.control.value != null && !this.selectedMember.id) this.findMemberFromTheList(this.control.value)
    }
  }
  get membersList() {
    return this._membersList;
  }

  selectedMember: Member = {name: '', id: '', profileImg: ''};
  @ViewChild('select') select: MatSelect | undefined;

  constructor() {
  }

  ngOnInit(): void {
    this.setListeners();
  }

  setListeners() {
    this.control.valueChanges.subscribe(val => {
      if (val) this.findMemberFromTheList(val)
    })
    // if (this.control.value != null) this.findMemberFromTheList(this.control.value)
  }

  findMemberFromTheList(id: string) {
    const member = this.membersList.find((m: Member) => m.id === id)
    //console.log({member});

    this.selectedMember = member ? member : {name: '', id: '', profileImg: ''};
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.select?.open();
    }
  }

  openedSelect(event: boolean) {
    this.editMode = event;
  }

  getInitials(name: string) {
    if (!name) return 'N/A';
    const splitName = name?.trim().toLocaleUpperCase().split(' ');
    return splitName.length > 1 ? splitName[0][0] + (splitName[1][0] ? splitName[1][0] : '') : splitName[0][0]
  }

}
